<template>
  <div class="copyright" v-if="show">
    <div class="text">
      确认患者行程数据由&nbsp;
    </div>
    <img :src="imageMap.logo" alt="" class="logo">
    <div class="text">
      &nbsp;整理提供
    </div>
  </div>
</template>

<script>
  import imageMap from '../../image-map.js';

  export default {
    data() {
      return { imageMap };
    },

    computed : {
      show() {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        return ptid === 'xiaomi';
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./copyright.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/copyright.vue